// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";

export function AdminHomeIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3L4 9v12h5v-7h6v7h5V9z"/>
        </svg>
    );
}

export function AdminDatabaseIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"/>
        </svg>
    );
}

export function AdminAppStoreIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"/>
        </svg>
    );
}

export function AdminLaptopIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
        </svg>
    );
}

interface AdminTopNavProps {
    activeTab?: "home" | "database" | "appstore" | "brandmylaptop" | "dashboard";
    navPinned: boolean;
    onTogglePin: () => void;
}

export default function AdminTopNav({ activeTab = "home", navPinned, onTogglePin }: AdminTopNavProps) {
    return (
        <nav className={`admin-topnav sticky top-[10px] z-[50] mb-[14px] flex items-center gap-[10px] rounded-[12px] bg-bg/95 p-[8px] shadow-[0_4px_16px_rgba(0,0,0,0.08)] backdrop-blur ${navPinned ? ' admin-topnav-pinned' : ''}`}>
            <Link
                to="/admin"
                className={`admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px] ${activeTab === 'home' ? 'admin-topnav-active' : ''}`}
                title="Home"
            >
                <AdminHomeIcon />
            </Link>
            <Link
                to="/admin/database"
                className={`admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px] ${activeTab === 'database' ? 'admin-topnav-active' : ''}`}
                title="Database"
            >
                <AdminDatabaseIcon />
            </Link>
            <Link
                to="/admin/app-store-settings"
                className={`admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px] ${activeTab === 'appstore' ? 'admin-topnav-active' : ''}`}
                title="App Store Kill Switch"
            >
                <AdminAppStoreIcon />
            </Link>
            <Link
                to="/admin/brand-my-laptop"
                className={`admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px] ${activeTab === 'brandmylaptop' ? 'admin-topnav-active' : ''}`}
                title="Brand My Laptop"
            >
                <AdminLaptopIcon />
            </Link>
            <Link
                to="/admin/user-dashboard"
                className={`admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px] ${activeTab === 'dashboard' ? 'admin-topnav-active' : ''}`}
                title="Dashboard"
            >
                <i className="fi fi-ss-chart-pie" style={{ fontSize: 20, lineHeight: 1, display: "flex", alignItems: "center" }}></i>
            </Link>
            <button
                className={`admin-topnav-pin-btn ml-auto flex h-[36px] items-center justify-center rounded-[8px] border border-slider px-[10px] ${navPinned ? ' admin-topnav-pin-active' : ''}`}
                onClick={onTogglePin}
                title={navPinned ? "Unpin nav" : "Pin nav"}
            >
                <i className="fi fi-sr-thumbtack"></i>
            </button>
        </nav>
    );
}
